import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useSystemPropertiesFilter } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { PropertiesModel, PropertyValue } from "../../../shared/models/metadata.model";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface SystemPropertyFilterValuesProps {
    propertyNameArg?: string | null,
    children?: ReactNode,
}

/***
 * Array source that returns the values of a filter for a system property.
 */
export const SystemPropertyFilterValues = React.memo(function SystemPropertyFilterValues({ propertyNameArg, children }: SystemPropertyFilterValuesProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const systemProperties: PropertiesModel = useSystemPropertiesFilter();

    // Get the property name from the property child unless it was provided as a prop
    const [propertyName, setPropertyName] = useState("");
    const propertyChild = useMemo(() => propertyNameArg ? null : findFirstComponentOfType(children, "arg-property"), [children, propertyNameArg]);

    useEffect(() => {
        const usedPropertyName = propertyNameArg || propertyName;
        if (usedPropertyName) {
            let values: Array<SourceItem> = [];
            values = systemProperties?.[usedPropertyName]?.map((value: PropertyValue, ix: number) => {
                return {
                    value: value,
                    props: {},
                    position: ix + 1,
                };
            }) || [];
            setArray(values);
        }
    }, [systemProperties, propertyName, propertyNameArg, setArray]);

    return <>
        <TextExtractor onExtractedText={setPropertyName}>
            {propertyChild?.props.children}
        </TextExtractor>
    </>;
});